import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import palette from '../styles/palette';

import HeaderOptions from './HeaderOptions';
import Table from '../common/Table';
import TableBottomOptions from './ParcelDetails/BottomOptions';
import BottomOptions from './BottomOptions';
import { isParcelDetailAvailable } from '../../features/routeDetail/model';
import layout from '../styles/layout';

const useStyles = makeStyles(({ typography }) => ({
  container: {
    right: 0,
    height: 360,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: `calc(100vw - ${layout.routeList.width}px)`,
    alignSelf: 'flex-end',
    background: palette.typography.black.medium,
  },
  tableContainer: {
    position: 'relative',
    height: 195,
    background: palette.typography.black.inactive,
    margin: `0 ${typography.pxToRem(20)}`,
    borderRadius: `10px 10px 0px 10px`,
    padding: `${typography.pxToRem(9)} ${typography.pxToRem(
      5
    )} ${typography.pxToRem(11)} ${typography.pxToRem(15)}`,
  },
}));

const useTableStyles = makeStyles(({ typography }) => ({
  tableWrap: {
    height: '100%',
    scrollbarWidth: 'thin',
    overflowY: 'auto',
    overflowX: 'hidden',

    '&::-webkit-scrollbar': {
      width: typography.pxToRem(6),
    },

    '&::-webkit-scrollbar-corner': {
      width: typography.pxToRem(16),
    },

    '&::-webkit-scrollbar:horizontal': {
      height: 0,
    },

    '&::-webkit-scrollbar-track': {
      background: palette.typography.white.neutral,
    },

    '&::-webkit-scrollbar-thumb': {
      background: palette.typography.white.disabled,
    },
  },
  greyRow: {
    background: palette.typography.white.neutral,
  },
  bodyCell: {
    borderColor: palette.typography.white.ghost,
    cursor: 'default',
    height: '1px',
  },
  footerCell: {
    border: 'none',
  },
  table: {
    marginRight: `${typography.pxToRem(5)}`,
    scrollbarWidth: 'thin',
  },
  selectedRow: {
    backgroundColor: palette.selectedStopDetailsListRow,
  },
}));

const RouteManagement = ({
  selectedStops,
  tableProps,
  routeManagementActionButtonsConfig,
  onChangeBulk,
  handleBackClick,
  onClickAddNewCriteria,
  handleRowClick,
  isBulkDisabled,
  isSplitDisabled,
  isTransferDisabled,
  selectedCriteria,
  onRemoveCriteria,
  onSplitClick,
}) => {
  const classes = useStyles();
  const tableClasses = useTableStyles();
  const isParcelDetails = isParcelDetailAvailable(selectedStops);

  return (
    <Box className={classes.container}>
      <HeaderOptions
        onClickBack={handleBackClick}
        onClickAdd={onClickAddNewCriteria}
        selectedCriteria={selectedCriteria}
        onRemoveCriteria={onRemoveCriteria}
      />
      {isParcelDetails && (
        <Box className={classes.tableContainer}>
          <Table
            {...tableProps}
            isStopList
            handleRowClick={handleRowClick}
            classes={tableClasses}
            isParcelDetails
          />
          <TableBottomOptions
            onChangeBulk={onChangeBulk}
            isBulk={selectedStops[0].bulk}
            isBulkDisabled={isBulkDisabled}
            onSplitClick={onSplitClick}
            isSplitDisabled={isSplitDisabled}
            isTransferDisabled={isTransferDisabled}
          />
        </Box>
      )}
      <BottomOptions
        isParcelDetails={isParcelDetails}
        selectedStops={selectedStops}
        buttonsActionConfig={routeManagementActionButtonsConfig}
      />
    </Box>
  );
};

export default RouteManagement;
